import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const resolveSrc = (p) => {
  if (!p) return "";
  if (p.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${p}`;
  return p;
};

export const telHref = (t) => `tel:+33${(t || "").replace(/\D/g, "").replace(/^0/, "")}`;

export const defaultSettings = {
  telephone: "06 95 40 85 22",
  email: "alexisdelcey884@gmail.com",
  zone: "Grand Angoulême & Grand Cognac",
  villes: [
    "Angoulême", "Soyaux", "Champniers", "Douzat", "Ruelle-sur-Touvre", "Saint-Yrieix-sur-Charente",
    "Cognac", "Jarnac", "Sigogne", "Châteaubernard", "Segonzac", "et les communes alentour",
  ],
  hero: "/chantiers/hero.jpg",
  entreprise: "Alexis Peinture",
  gerant: "Alexis Delcey",
  legal: {
    formeJuridique: "À compléter (ex. entreprise individuelle)",
    siret: "À compléter",
    adresse: "À compléter (siège social)",
  },
};

let siteCache = null;
let sitePromise = null;

export function useSiteData(fallback) {
  const [data, setData] = useState(siteCache);
  useEffect(() => {
    if (siteCache) {
      setData(siteCache);
      return;
    }
    if (!sitePromise) {
      sitePromise = Promise.all([
        api.get("/chantiers").then((r) => r.data).catch(() => null),
        api.get("/services").then((r) => r.data).catch(() => null),
        api.get("/settings").then((r) => r.data).catch(() => null),
      ]).then(([chantiers, services, settings]) => {
        siteCache = { chantiers, services, settings };
        return siteCache;
      });
    }
    sitePromise.then(setData);
  }, []);
  return data || fallback;
}

export function invalidateSiteCache() {
  siteCache = null;
  sitePromise = null;
}
